import OrderShipmentDateMethodStrategy from "@/domain/OrderShipmentDateMethodStrategy";

export const DefineByExecutor = new OrderShipmentDateMethodStrategy(0, "Определяется поставщиком")
export const FromOrderDateToOrderExpires = new OrderShipmentDateMethodStrategy(1, "С даты заказа по дате истечения срока заказа")